
import React from 'react';
import Messages from '../components/Messages';
import Footer from '../components/Footer';


function MessagesPage() {
  return (
    <>
        <Messages />
        <Footer />
    </>
  );
}


export default MessagesPage;
